import { siteName, siteUrl } from "../content";

export function personSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Robert Doe",
    url: siteUrl,
    jobTitle: "PhD Student, Computer Science (Cybersecurity)",
    worksFor: {
      "@type": "CollegeOrUniversity",
      name: "Arizona State University",
    },
    alumniOf: [
      { "@type": "CollegeOrUniversity", name: "Arizona State University" },
      {
        "@type": "CollegeOrUniversity",
        name: "Kwame Nkrumah University of Science and Technology",
      },
    ],
    sameAs: ["https://github.com/Robert-Doe/", "https://linkedin.com/in/robert-doe/"],
    knowsAbout: [
      "Web Security",
      "Machine Learning",
      "Memory Safety",
      "Penetration Testing",
      "Compilers",
      "Operating Systems",
      "Human-Computer Interaction",
    ],
    email: "mailto:robertdoe009@gmail.com",
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteName,
    url: siteUrl,
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${siteUrl}${item.path}`,
    })),
  };
}

export function certificateSchema(cert) {
  let dateCreated;
  const parsed = new Date(cert.date);
  if (!Number.isNaN(parsed.getTime())) {
    dateCreated = parsed.toISOString().slice(0, 10);
  }

  return {
    "@context": "https://schema.org",
    "@type": "EducationalOccupationalCredential",
    name: cert.title,
    credentialCategory: "Certificate of Completion",
    recognizedBy: {
      "@type": "Organization",
      name: cert.issuer,
    },
    dateCreated,
    url: `${siteUrl}/certificates/${cert.slug}`,
    about: cert.tags?.join(", "),
  };
}

export function certificateListSchema(certs) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: certs.map((cert, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${siteUrl}/certificates/${cert.slug}`,
      name: cert.title,
    })),
  };
}
